import React, { useState } from 'react'
import { Field } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { renderers } from '../components'

export const DateFilter = ({ name, label }) => {
  return (
    <ReactBootstrap.Col xs={12}>
      <Field
        name={name}
        label={label}
        dateFormat="MMMM d, yyyy h:mm aa"
        component={renderers.renderDateTimePicker}
      />
    </ReactBootstrap.Col>
  )
}

export const StringFilter = ({ name, label }) => {
  return (
    <ReactBootstrap.Col xs={12}>
      <Field name={name} label={label} component={renderers.renderField} />
    </ReactBootstrap.Col>
  )
}

export const OptionsField = ({ name, label, options }) => {
  return (
    <ReactBootstrap.Col xs={12}>
      <Field
        component={renderers.renderSelectField}
        as="select"
        name={name}
        label={label}
      >
        {options &&
          options.map((opt) => (
            <option key={opt.code} value={opt.code}>
              {opt.label}-{opt.code}
            </option>
          ))}
      </Field>
    </ReactBootstrap.Col>
  )
}

export const RadioField = ({ name, label }) => {
  return (
    <ReactBootstrap.Col xs={12}>
      <Field
        component={renderers.renderRadioField}
        name={name}
        label={label}
      ></Field>
    </ReactBootstrap.Col>
  )
}

export const SearchModal = ({
  buttonIcon,
  buttonText,
  modalHeading,
  children,
  modalSize,
  className,
  onShow,
  mode = 'DropdownItem',
}) => {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <>
      <ReactBootstrap.Modal
        size={modalSize ? modalSize : ''}
        backdrop="static"
        show={show}
        onHide={handleClose}
        onShow={onShow ? onShow : () => {}}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            {modalHeading}
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>{children}</ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer></ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>

      {mode !== 'DropdownItem' ? (
        <ReactBootstrap.Button
          variant="dark"
          className={className}
          onClick={(e) => {
            handleShow()
          }}
        >
          {buttonIcon}
          {buttonText}
        </ReactBootstrap.Button>
      ) : (
        <ReactBootstrap.NavDropdown.Item
          onClick={(e) => {
            handleShow()
          }}
        >
          {buttonIcon}
          {buttonText}
        </ReactBootstrap.NavDropdown.Item>
      )}
    </>
  )
}

export const GSXModal = SearchModal
